import {ApplicationConfig, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {provideAnimations} from '@angular/platform-browser/animations';
import {ButtonModule} from 'primeng/button';
import {provideRouter} from '@angular/router';
import {appRoutes} from './app.routes';
import {HttpClientModule, provideHttpClient, withInterceptors} from '@angular/common/http';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {providePrimeNG} from 'primeng/config';
import Aura from '@primeng/themes/aura';
import {ToastModule} from 'primeng/toast';
import {DialogService, DynamicDialogModule} from 'primeng/dynamicdialog';
import {DialogModule} from 'primeng/dialog';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {FullCalendarModule} from '@fullcalendar/angular';
import {authInterceptor} from './interceptors/auth.interceptor';
import {MessageService} from 'primeng/api';
import { http401Interceptor } from './interceptors/http-401-interceptor';

export const appConfig: ApplicationConfig = {

  providers: [provideZoneChangeDetection({eventCoalescing: true}),
    provideAnimations(),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false
        }
      }
    }),
    DialogService,
    MessageService,
    importProvidersFrom(
      ButtonModule,
      ToastModule,
      DialogModule,
      HttpClientModule,
      DynamicDialogModule,
      ConfirmDialogModule,
    ),
    provideHttpClient(withInterceptors([http401Interceptor,authInterceptor])),
    importProvidersFrom(FullCalendarModule),
    provideRouter(appRoutes)]
};
